const RouteNames = {
    workreply: {
        add: "work-reply/add",
        edit: "work-reply/edit",
        home: "work-reply"
    },
    workleads: {
        home: "work-leads",
        emailVerifier: "work-leads/emailVerifier",
        emailSender: "work-leads/emailSender"
    },
    workmail: {
        home: "work-mail",
        emailInbox: (inboxId) => `work-mail/${inboxId}/inbox`,
        emailView: (inboxId, emailId) => `work-mail/${inboxId}/inbox/${emailId}`
    },
    workmeet: {
        home: "work-meet",
        calendarView: (calendarId) => `work-meet/calendar/${calendarId}/`,
        schedule: (path) => `work-meet/calendar/schedule/${path}`,
        scheduled: (meetingId) => `work-meet/calendar/meeting-scheduled/${meetingId}`,
        bookingTable: "work-meet/bookings"
    },
    workcontent: {
        home: "work-content",
        generator: (projectId) => `work-content/generator/${projectId}`,
        projects: "work-content/projects",
        pinned: "work-content/pinned"
    },
    workencrypt: {
        home: "work-encrypt",
        viewSecret: (linkId) => `work-encrypt/view/${linkId}`,
        secret: "work-encrypt/all",
    },
    workreview: {
        home: "work-review",
        rating: (linkId) => `work-review/rating/${linkId}`,
        feedback: (linkId) => `work-review/feedback/${linkId}`,
        review: (linkId) => `work-review/review/${linkId}`,
        thankYou: (linkId) => `work-review/thankyou/${linkId}`,
    },
    workiterate: {
        project: (projectId, tool) => `work-iterate/${projectId}/${tool}`,
        tactic: (projectId, tool, tacticId) => `work-iterate/${projectId}/${tool}/${tacticId}`,
        tacticsFunnel: (projectId, tool, funnelId, service) => `work-iterate/${projectId}/${tool}/${funnelId}/${service}`,
    },
    workflow: {
        home: (name) => `work-flow/${name}`,
    },
    auth: {
        signIn: "login",
        signUp: "register",
        emailConfirmation: "emailConfirmation",
        emailConfirmed: "emailConfirmed",
        forgotPassword: "forgotPassword",
        changePassword: "changePassword",
    },
    google: {
        serviceAuth: "connect-google-service"
    },
    user: {
        settings: "userSettings"
    },
    home: "/"
}
export default RouteNames